import { X } from 'lucide-react';
import React from 'react';

const ModalHeader = ({
  title,
  description,
  onClose,
  closeDisabled,
}: {
  title: string;
  /** Podtytuł pod nazwą okna, np. sekcja i typ edytowanego pola. */
  description?: string;
  onClose: () => void;
  closeDisabled?: boolean;
}) => {
  return (
    <div className="sticky top-0 z-10 flex w-full flex-row items-center justify-between gap-3 bg-basic-white px-4 pt-4">
      <div className="min-w-0">
        <h2 className="break-words text-2xl font-semibold text-base-text">
          {title}
        </h2>
        {description && (
          <p className="mt-1 text-[13px] text-neutral-500">{description}</p>
        )}
      </div>
      <button
        onClick={onClose}
        disabled={closeDisabled}
        className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md hover:bg-neutral-50 disabled:pointer-events-none disabled:opacity-40"
      >
        <X className="text-neutral-900" size={20} />
      </button>
    </div>
  );
};

export default ModalHeader;
